import { Box, Field, HStack, Input, Text, Textarea, VStack } from "@chakra-ui/react";

const Row = ({ children }) => (
    <HStack w="full" gap={4} align="flex-start" flexWrap="wrap">{children}</HStack>
);

const TextField = ({ label, value, onChange, required, type = "text" }) => (
    <Box flex="1" minW="200px">
        <Field.Root required={required}>
            <Field.Label color="white" fontSize={14}>
                {label} {required && <Field.RequiredIndicator />}
            </Field.Label>
            <Input variant="primary" fontSize={16} py={5} type={type} value={value} onChange={(e) => onChange(e.target.value)} />
        </Field.Root>
    </Box>
);

const Section = ({ title, children }) => (
    <VStack gap={3} align="flex-start" w="full">
        <Text color="white" fontWeight={700} fontSize="sm">{title}</Text>
        {children}
    </VStack>
);

/** The combined owner + company + billing fields, shared by Add Client and Edit client. */
const CompanyOwnerFormFields = ({ form, set }) => (
    <VStack gap={6} align="flex-start" w="full">
        <Section title="Owner">
            <Row>
                <TextField label="First name" value={form.firstName} onChange={set("firstName")} required />
                <TextField label="Last name" value={form.lastName} onChange={set("lastName")} required />
            </Row>
            <TextField label="Email" value={form.email} onChange={set("email")} required type="email" />
            <TextField label="Phone" value={form.phoneNumber} onChange={set("phoneNumber")} />
            <Box w="full">
                <Field.Root>
                    <Field.Label color="white" fontSize={14}>Additional info</Field.Label>
                    <Textarea variant="primary" value={form.additionalInfo} onChange={(e) => set("additionalInfo")(e.target.value)} />
                </Field.Root>
            </Box>
        </Section>

        <Section title="Company">
            <TextField label="Company name" value={form.companyName} onChange={set("companyName")} />
            <Row>
                <TextField label="NIP" value={form.companyNip} onChange={set("companyNip")} />
                <TextField label="Website" value={form.companyWebsite} onChange={set("companyWebsite")} />
            </Row>
        </Section>

        <Section title="Billing address">
            <Row>
                <TextField label="Street" value={form.billingStreet} onChange={set("billingStreet")} />
                <TextField label="Building number" value={form.billingBuildingNumber} onChange={set("billingBuildingNumber")} />
            </Row>
            <Row>
                <TextField label="Postal code" value={form.billingPostalCode} onChange={set("billingPostalCode")} />
                <TextField label="City" value={form.billingCity} onChange={set("billingCity")} />
                <TextField label="Country" value={form.billingCountry} onChange={set("billingCountry")} />
            </Row>
        </Section>
    </VStack>
);

export default CompanyOwnerFormFields;
